export default function Stats() {
  const stats = [
    {
      value: '1,378+',
      label: 'Churches',
    },
    {
      value: '850+',
      label: 'Ministries',
    },
    {
      value: '35+',
      label: 'Conferences',
    },
    {
      value: '3',
      label: 'Unions',
    }
  ];

  return (
    <div className="relative -mt-20 z-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-gray-900/90 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 sm:p-6 lg:p-8 shadow-2xl border border-gray-800"
            >
              <div className="text-center space-y-1">
                <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-emerald-600 mb-1 lg:mb-2" style={{ fontFamily: 'Noto Sans, system-ui, sans-serif' }}>
                  {stat.value}
                </div>
                <div className="text-xs sm:text-sm font-medium text-gray-300 uppercase tracking-wide">
                  {stat.label}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
